import React, { useState, useEffect, useContext } from 'react'
import './controlreference.css'
import { ThemeProvider, createTheme } from '@mui/material';
import MaterialTable from 'material-table';
import { BsSearch } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom';

import Modal from "react-modal";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment'

import { GET, POST } from '../Common/HttpMethods/HttpMethods';
import { Url } from '../../constants/ApiUrlConstants';
import { contextData } from '../../context/ContextProvider';
import FailModal from '../Common/Popups/FailModal';
import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { createTableIcons, Cuurent_EMAIL, Cuurent_RBAC_roles, Cuurent_USER_ROLES, Cuurent_USERNAME, extractMeetingData, extractTextFromHtml, getAllToFromOptionalEmailArr, stripHtmlTags } from '../CommonCase/CommonFunctions';
import { tableHeaderStyle } from '../CommonCase/CommonFunctions';
import UpcomingMeetingModal from '../CommonCase/UpcomingMeetingModal';
import CancelledMeetingModal from '../CommonCase/CancelledMeetingModal';

const localizer = momentLocalizer(moment)

export const isOverflowing = (element) => {
  return element?.scrollHeight > element?.clientHeight || element?.scrollWidth > element?.clientWidth;
}

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}

export const handleCref_C_CloseModalOnRequest = (handleCloseFullView,setFullViewCancelModal,setFullView) => { 
  handleCloseFullView(setFullView);
   setFullViewCancelModal(false) 
  }
  
  export const handleDateChange = (name, date,setSelectedToDate,setSelectedFromDate) => {
    if (name == "ToDate") {
      setSelectedToDate(date)
    }else {
      setSelectedFromDate(date)
    }
  }


  export const handleCloseFullView = (setFullView) => {
    setFullView((prevState) => ({
      isClicked: false,
      viewMoreAttendees: false,
      typeOfMeeting: null,
      data: {}
    }));
  }



export const handleOpenFullView = async (meetData, setLoading, token, setFullView, setFullViewCancelModal, setFullViewModal, setSessionExpiredModal, setFailMessage) => {

  console.log("meetData=======", meetData)

  setLoading(true);


  const meeetingData = await GET(Url.GetMeetingMomByMeetingId.replace('{meetingId}', `${meetData?.mid}`).replace("{isAttendeeRequired}", "Y"), token);

  if (meeetingData.SUCCESS) {

    const { meetingSubject, startTime, endTime, emailDetails, meetingAgenda, cancelReason, cancelledByName, meetingLocation, message } = meeetingData?.DATA;



    const data = extractMeetingData(meeetingData?.DATA);


    setFullView((prevState) => ({ isClicked: true, typeOfMeeting: meetData?.typeOfMeeting, viewMore: false, viewMoreAttendees: false, viewMoreMsg: false, data: data }));

    setLoading(false);
    meetData?.typeOfMeeting == "Upcoming" || meetData?.typeOfMeeting == "Ongoing" ? setFullViewModal(true) : setFullViewCancelModal(true)

  }
  else if (meeetingData?.STATUS == 401) {
    setLoading(false)

    setSessionExpiredModal(true)
    setFailMessage("Session expired");
  }
}

export const handleOnRequestCRfCloseUPMModal = (handleCloseFullView, setFullView,setFullViewModal, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight) => {
  handleCloseFullView(setFullView); 
  setFullViewModal(false); 
  setAgendaDivHeight(false);
  setMsgDivHeight(false);
  setAttendeesDivHeight(false)
}



export function handleToDateChange(date, selectedToDate, handleDateChange, setSelectedToDate, setSelectedFromDate) {
  const selectedToTimestamp = selectedToDate && selectedToDate.getTime();
  const dateTimestamp = date && date.getTime();
  if (selectedToTimestamp !== dateTimestamp) {
    handleDateChange("ToDate", date, setSelectedToDate, setSelectedFromDate);
  }
}

export function filterDataWithSearchInput(dataCopy, searchInput, setData) {
  if (searchInput === "") {
    setData(dataCopy);
  } else {
    setData(
      dataCopy?.filter((i) => {
        return (
          i.controlRefNo == searchInput || 
          (i?.tags?.toString().toLowerCase()) === searchInput?.toString().toLowerCase()
        );
      })
    );
  }
}

export const myFormats = (monthlyCount) => ({
  monthHeaderFormat: (date) => {
    // Format the date as desired, for example: "January 2024 (5)"
    return `${moment(date).format('MMMM YYYY')} (${monthlyCount.currentCount})`;
  },
});

export const CustomEvent = ({  event,
  setLoading,
  token,
  setFullView,
  setFullViewCancelModal,
  setFullViewModal,
  setSessionExpiredModal,
  setFailMessage,
  setViewPastMeeting,
  setFromPastMeeting,
  navigate,
  rbac,
  usermail, }) => {
  const renderMeetingItem = (item, index) => {
    const borderStyle = {
      borderLeft: `4px solid ${getBorderColor(item.deptartmentTagMaster?.deptTag)}`
    };

    const textStyle = {
      color: getTextColor(item.deptartmentTagMaster?.deptTag)
    };

    // const handleOnClick = () => {
    //   if (item.typeOfMeeting === "Upcoming" || item.typeOfMeeting === "Cancelled" || item.typeOfMeeting === "Ongoing") {
    //     handleOpenFullView(item,  setLoading, token, setFullView, setFullViewCancelModal, setFullViewModal, setSessionExpiredModal, setFailMessage);
    //   } else if (item.typeOfMeeting === "Past") {
    //     navigateToMeeting(item,setViewPastMeeting, setFromPastMeeting, navigate, rbac, usermail);
    //   }
    // };

    return (
      <div className='tooltip-controll-item'  onClick={()=>handleOnClick(item, handleOpenFullView,setLoading, token, setFullView, setFullViewCancelModal, setFullViewModal, setSessionExpiredModal, setFailMessage,setViewPastMeeting, setFromPastMeeting, navigate, rbac, usermail)} key={index} style={borderStyle}>
        <div className='modal-popup-container'>
          <div className='modal-popup-meetingsubject-style' style={textStyle}>
            {item.meetingSubject}
          </div>
          <div className='modal-popup-time-cont'>
            <div className='modal-popup-time-text'>Time : {item.startTime} - {item.endTime === "11:59 PM" ? "12:00 AM" : item.endTime}</div>
            <div style={{ width: "40%", textAlign: "left" }}>{renderMeetingStatus(item)}</div>
          </div>
        </div>
        <div className='modal-popup-container'>
          <div className='modal-popup-meetingsubject-style2' style={textStyle}>{item.deptartmentTagMaster?.deptTag}</div>
          <div className='modal-popup-mom-container'>{renderMomButton(item)}</div>
        </div>
      </div>
    );
  };

  const getBorderColor = (deptTag) => {
    switch (deptTag) {
      case "HR":
        return "#700098";
      case "IT":
        return "#4CB87C";
      case "Governance":
        return "#057DAA";
      default:
        return "#FF9B00";
    }
  };

  const getTextColor = (deptTag) => {
    switch (deptTag) {
      case "HR":
        return "#700098";
      case "IT":
        return "#4CB87C";
      case "Governance":
        return "#057DAA";
      default:
        return "#FF9B00";
    }
  };

 

  // const renderMeetingStatus = (item) => {
  //   if (item.typeOfMeeting === "Past") {
  //     return <span>Duration : {item.duration}</span>;
  //   } else {
  //     return <span>Status : <span style={{ color: item.typeOfMeeting === "Cancelled" && "red" }}>{item.typeOfMeeting}</span></span>;
  //   }
  // };

  // const renderMomButton = (item) => {
  //   if (item.typeOfMeeting === "Past") {
  //     return <div>MOM : {item.hasMOM === "N/A" ? "N/A" : " View"}</div>;
  //   } else if (item.typeOfMeeting === "Ongoing") {
  //     return <button className='Join-btn-styling'>JOIN</button>;
  //   } else {
  //     return null;
  //   }
  // };

  return (
    <div className="toolbar-container">
      <div style={{ margin: 0 }}>{event?.calendarIntegrationDTO?.length} Meetings</div>
      <div className="control-tooltip-wraper">
        <div className="controll-ref-tooltip-triangle"></div>
      </div>
      <div className="event-tooltip">
        {event?.calendarIntegrationDTO?.map((item, index) => renderMeetingItem(item, index))}
      </div>
    </div>
  );
};



export const navigateToMeeting = (metingData, setViewPastMeeting, setFromPastMeeting, navigate, rbac, usermail) => {
  const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(metingData?.participantsList);
  if (metingData?.typeOfMeeting == "Past" && metingData?.hasMOM == "view") {


    setViewPastMeeting({ isView: true, meetingId: metingData?.mid })
    setFromPastMeeting('cref')

    navigate("/main/meetings/my-meetings")
  }
  else if ((allEmailIdArr?.includes(usermail)) &&
    rbac?.editAccess === "Y") {

    navigate("/main/meetings/edit-past-meeting", { state: { meetingId: metingData.mid } });
  }

}

export const handleOnClick = (item, handleOpenFullView,setLoading, token, setFullView, setFullViewCancelModal, setFullViewModal, setSessionExpiredModal, setFailMessage,setViewPastMeeting, setFromPastMeeting, navigate, rbac, usermail) =>{
    
      if (item.typeOfMeeting === "Upcoming" || item.typeOfMeeting === "Cancelled" || item.typeOfMeeting === "Ongoing") {
        handleOpenFullView(item,  setLoading, token, setFullView, setFullViewCancelModal, setFullViewModal, setSessionExpiredModal, setFailMessage);
      } else if (item.typeOfMeeting === "Past") {
        navigateToMeeting(item,setViewPastMeeting, setFromPastMeeting, navigate, rbac, usermail);
      }
};

export const handleSessionExpClose = (sessionStorage, navigate, setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
};

export const handleSetPressedMeetingData = (rowData, setModalIsOpen, setSelectedControlRef) => {
  setModalIsOpen(true);
  setSelectedControlRef(rowData);
};


export const renderMeetingStatus = (item) => {
     if (item.typeOfMeeting === "Past") {
      return <span>Duration : {item.duration}</span>;
    } else {
      return <span>Status : <span style={{ color: item.typeOfMeeting === "Cancelled" && "red" }}>{item.typeOfMeeting}</span></span>;
    }
};

export const renderMomButton = (item) => {
  if (item.typeOfMeeting === "Past") {
        return <div>MOM : {item.hasMOM === "N/A" ? "N/A" : " View"}</div>;
      } else if (item.typeOfMeeting === "Ongoing") {
        return <button className='Join-btn-styling'>JOIN</button>;
      } else {
        return null;
      }
};

export const handlePrevMonth = (datePickerDate, setDatePickerDate) => {
  const newDate = new Date(datePickerDate);
  newDate.setDate("01");
  newDate.setMonth(newDate.getMonth() - 1);
  setDatePickerDate(newDate);
};

export const handleNextMonth = (datePickerDate, setDatePickerDate) => {
  const newDate = new Date(datePickerDate);
  newDate.setDate("01");
  newDate.setMonth(newDate.getMonth() + 1);
  setDatePickerDate(newDate);
};

export const closeModal = (setModalIsOpen, setFullView, setDatePickerDate) => {
  setModalIsOpen(false);
  setFullView({ isClicked: false, viewMoreAttendees: false, typeOfMeeting: null, data: {} });
  setDatePickerDate(new Date());
};

export const getCalendarDataByView = async ({
  monthStartDate,
  monthEndDate,
  selectedFromDate,
  selectedToDate,
  selectedControlRef,
  setLoading,
  setMonthlyEvents,
  setMonthlyCount,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  POST,
  token
}) => {
  try {
    setLoading(true);

    const calendarMeetingResp = await POST(Url.getMeetingsByCalendarTypeAndControlRef, token, {
      "startDate": monthStartDate,
      "endDate": monthEndDate,
      "startDateOfControlRef": moment(selectedFromDate).format('YYYY-MM-DD'),
      "endDateOfControlRef": moment(selectedToDate).format('YYYY-MM-DD'),
      "calendarType": "month",
      "controlRefId": selectedControlRef?.controlRefId
    });

    if (calendarMeetingResp.SUCCESS) {
      let data = calendarMeetingResp?.DATA?.monthlyData?.map((i) => {
        let d = i?.meetingStartDate?.split("-");

        return {
          ...i,
          start: new Date(d[0], d[1] - 1, d[2], 11, 0),
          end: new Date(d[0], d[1] - 1, d[2], 12, 0),
        };
      });

      setLoading(false);
      setMonthlyEvents(data);
      setMonthlyCount({
        prevCount: calendarMeetingResp?.DATA?.previousMonthMeetingCount,
        nextCount: calendarMeetingResp?.DATA?.nextMonthMeetingCount,
        currentCount: calendarMeetingResp?.DATA?.currentMonthMeetingCount
      });
    } else if (calendarMeetingResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (calendarMeetingResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (calendarMeetingResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (calendarMeetingResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (calendarMeetingResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage("Failed To Fetch Meetings");
      setOpenFailModal(true);
    }
  } catch (err) {
    setLoading(false);
    setFailMessage("Failed To Fetch Meetings");
    setOpenFailModal(true);
  }
};


export const checkOverflowAndSetHeights = (
  setAttendeesDivHeight,
  setAgendaDivHeight,
  setMsgDivHeight
) => {
  const div = document.getElementById("agenda_div");
  let res = isOverflowing(div); // Assuming isOverflowing is a utility function

  const div2 = document.getElementById("message_div");
  let res2 = isOverflowing(div2);

  const div3 = document.getElementById("attendees_div");
  let res3 = isOverflowing(div3);

  if (res3) {
    setAttendeesDivHeight(res3);
  }

  if (res) {
    setAgendaDivHeight(res);
  }

  if (res2) {
    setMsgDivHeight(res2);
  }
};


const ControlReference = () => {
  const { setViewPastMeeting, setActive, setLoading, setFromPastMeeting } = useContext(contextData);
  const navigate = useNavigate();

  // rbac roles
  let rrbac = Cuurent_RBAC_roles();
  const token = sessionStorage.getItem("TOKEN");
  // let Email = Cuurent_EMAIL();

  const storedRbacRoles = JSON.parse(rrbac);

  const userRole = sessionStorage.getItem("USER")

  const [rbac, setRbac] = useState({});

  useEffect(() => {
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Control Reference");
      if (roleWithQMSDashboard) {
        setRbac(roleWithQMSDashboard);
      }
    }
  }, []);



  // ---------------------------------------------------------------------------------- Data States -------------------------------------------------------------------------------
  const [data, setData] = useState([]);
  const [dataCopy, setCopyData] = useState([]);
  const [searchInput, setSearchInput] = useState("")
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)

  const [openActCOntrol, setOpenActControl] = useState({
    isClicked: false,
    selectedId: "",
  });
  const [view, setView] = useState('month'); // Default view is 'week'
  const [selectedControlRef, setSelectedControlRef] = useState("");
  const [FullViewModal, setFullViewModal] = useState(false);
  const [FullViewCancelModal, setFullViewCancelModal] = useState(false);

  const [fullView, setFullView] = useState({
    isClicked: false,
    viewMore: false,
    viewMoreMsg: false,
    viewMoreAttendees: false,
    typeOfMeeting: null,
    data: {}
  })
  // ---------------------------------------------------------------------------------- Boolean States -------------------------------------------------------------------------------
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [datePickerDate, setDatePickerDate] = useState(new Date());

  const [selectedToDate, setSelectedToDate] = useState();
  const [selectedFromDate, setSelectedFromDate] = useState();

  const [openToDatePicker, setOpenToDatePicker] = useState(false);
  const [openFromDatePicker, setOpenFromDatePicker] = useState(false);

  const [monthStartDate, setMonthStartDate] = useState()
  const [monthEndDate, setMonthEndDate] = useState()

  const [monthlyEvents, setMonthlyEvents] = useState([]);
  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  
  const [monthlyCount, setMonthlyCount] = useState({
    prevCount: 0,
    nextCount: 0,
    currentCount: 0
  })

  const [agendaDivHeight, setAgendaDivHeight] = useState(false);
  const [msgDivHeight, setMsgDivHeight] = useState(false);
  const [agendaDivHeightCancel, setAgendaDivHeightCancel] = useState(false);
  const [attendeesDivHeight, setAttendeesDivHeight] = useState(false)




  useEffect(() => {
    const timerId = setTimeout(() => {
      checkOverflowAndSetHeights(
        setAttendeesDivHeight,
        setAgendaDivHeight,
        setMsgDivHeight
      );
    }, 1000);

    return () => clearTimeout(timerId);
  }, [fullView]);

  useEffect(() => {
    setTimeout(() => {
      const div = document.getElementById("agenda_div_cancel");
      let res = isOverflowing(div)

      if (res) {
        setAgendaDivHeightCancel(res)
      }


    }, 1000);
  }, [fullView])
  //  fullViewCancel



  const modalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };



  useEffect(() => {
    const previousMonthFirstDate = moment().subtract(1, 'months').startOf('month');
    const nextMonthLastDate = moment().add(1, 'months').endOf('month');

    const formattedPreviousMonthFirstDate = previousMonthFirstDate.format('YYYY-MM-DD');
    const formattedNextMonthLastDate = nextMonthLastDate.format('YYYY-MM-DD');

    setSelectedFromDate(new Date(formattedPreviousMonthFirstDate));
    setSelectedToDate(new Date(formattedNextMonthLastDate));
  }, []);

  useEffect(() => {
    const currentDate = moment();
    const month = currentDate.month();
    const year = currentDate.year();
    const startDate = moment({ year, month }).startOf('month');
    const endDate = moment({ year, month }).endOf('month');
    setMonthStartDate(startDate.format('YYYY-MM-DD'))
    setMonthEndDate(endDate.format('YYYY-MM-DD'))
  }, [])


  useEffect(() => {
    const month = datePickerDate?.getMonth();
    const year = datePickerDate?.getFullYear();

    const startDate = moment({ year, month }).startOf('month');
    const endDate = moment({ year, month }).endOf('month');
    setMonthStartDate(startDate.format('YYYY-MM-DD'))
    setMonthEndDate(endDate.format('YYYY-MM-DD'))

  }, [datePickerDate])


  useEffect(() => {
    if (selectedControlRef) {
      getCalendarDataByView({
        monthStartDate,
        monthEndDate,
        selectedFromDate,
        selectedToDate,
        selectedControlRef,
        setLoading,
        setMonthlyEvents,
        setMonthlyCount,
        setSessionExpiredModal,
        setFailMessage,
        setOpenFailModal,
        POST,
        token
      });
    }
  }, [monthStartDate, selectedControlRef]);


  // const handleDateChange = (name, date) => {
  //   if (name == "ToDate") {
  //     setSelectedToDate(date)
  //   }
  //   else {
  //     setSelectedFromDate(date)
  //   }
  // }
  const titleStyle = {
    borderRight: "1px solid #b8b8b8",
    cursor: "pointer",
  }

  // ---------------------------------------------------------------------------------- Columns-------------------------------------------------------------------------------
  const columns = [
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', height: '100%', margin: '2px auto', display: 'flex', alignItems: 'center' }}>CONTROL REFERENCE</p>,
      field: "controlRefId",
      sorting: false,
      render: (rowData) => {
        return (
          <div style={{ ...titleStyle, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '8px' }} className="Cref-table-row-data">
            {rowData?.controlRefNo}
          </div>
        );
      },
    },
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', height: '100%', display: 'flex', alignItems: 'center' }}>DESCRIPTION</p>,
      field: "controlRefShort",
      sorting: false,
      rowSpan: 2,
      render: (rowData) => {
        return (
          <div style={{ ...titleStyle, position: "relative" }} className="Cref-table-row-data description-row">
            <span className='ellipsis' style={{ width: 135 }}>
              {rowData?.controlRefShort}
            </span>
            {rowData?.controlRefShort &&
              <div className='description-tool-tip'>
                {rowData?.controlRefShort}
              </div>}
          </div>
        );
      },
    },
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', height: '100%', display: 'flex', alignItems: 'center' }}>ACTUAL CONTROL</p>,
      field: "actualControlImplemented",
      sorting: false,
      render: (rowData) => {
        return (
          <div style={{ ...titleStyle, position: "relative" }}
            className="Cref-table-row-data actual-controll-col"
            onClick={() => { setOpenActControl({ isClicked: !openActCOntrol.isClicked, selectedId: rowData?.controlRefId }); }}
            onBlur={() => setTimeout(() => { setOpenActControl({ isClicked: false, selectedId: "" }) }, 500)}
          >
            <span className='ellipsis' style={{ width: 249 }}>
              {rowData?.actualControlImplemented}
            </span>
            {rowData?.actualControlImplemented &&
              <div className='cref-full-name'>
                {rowData?.actualControlImplemented}
              </div>}
          </div>
        );
      },
    },
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', height: '100%', display: 'flex', alignItems: 'center' }}>TAGS</p>,
      field: "tags",
      sorting: false,
      render: (rowData) => {
        return (
          <div style={{ ...titleStyle, position: 'relative' }} className="Cref-table-row-data tags-column">
            <span className='ellipsis' style={{ width: 80 }}>
              {rowData?.tags}
            </span>
            {rowData?.tags &&
              <div className='tags-full-name'>
                {rowData?.tags}
              </div>}
          </div>
        );
      },
    },
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', height: '100%', display: 'flex', alignItems: 'center' }}>ARTIFACTS</p>,
      field: "",
      sorting: false,
      render: (rowData) => {
        let str = "";
        rowData?.artifactMasters?.map((i, index) => {
          if (index + 1 == rowData?.artifactMasters?.length) {
            str = str + `${i.artifactName}`
          } else {
            str = str + `${i.artifactName},`
          }
        })
        return (
          <div style={{ ...titleStyle, position: "relative" }} className="Cref-table-row-data artifacts-row">
            <span className='ellipsis' style={{ width: "244px" }}>
              {str}
            </span>
            {
              str && <div className='artifacts-tool-tip'>
                {str}
              </div>
            }

          </div>
        )
      },
    },
    {
      title: <p style={{ borderRight: '1px solid #b8b8b8', height: '100%', display: 'flex', alignItems: 'center' }}>FREQUENCY</p>,
      field: "",
      sorting: false,
      render: (rowData) => (
        <div style={titleStyle} className="Cref-table-row-data">
          {rowData?.frequency}
        </div>
      ),
    },
    {
      title: <p>MEETINGS</p>,
      field: "",
      sorting: false,
      render: (rowData) => (
        <div onClick={() => handleSetPressedMeetingData(rowData, setModalIsOpen, setSelectedControlRef)}
          style={{ ...titleStyle, borderRight: "none" }} className="Cref-table-row-data">
          <p className='meetings-popup-btn'> {rowData?.meetingCount} {rowData?.meetingCount <= 1 ? "Meeting" : "Meetings"}</p>

        </div>
      ),
    },
  ];

  const CustomMonthHeader = ({ label }) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span
          style={{
            backgroundColor: "#EAF7FC",
            padding: "1px 5px",
            display: "flex",
            justifyContent: 'space-around',
            alignItems: "center",
            width: 170,
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
            cursor: 'pointer'
          }}
          onClick={() => handlePrevMonth(datePickerDate, setDatePickerDate)}
        >
          <MdOutlineKeyboardDoubleArrowLeft />
          <span>Previous Month ({monthlyCount.prevCount})</span>
        </span>
        <span>{label}</span>
        <span
          style={{
            backgroundColor: "#EAF7FC",
            padding: "1px 5px",
            display: "flex",
            justifyContent: 'space-around',
            alignItems: "center",
            width: 150,
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
            cursor: 'pointer'
          }}
          onClick={() => handleNextMonth(datePickerDate, setDatePickerDate)}
        >
          <span>Next Month ({monthlyCount.nextCount})</span>
          <MdOutlineKeyboardDoubleArrowRight />
        </span>
      </div>
    );
  };



  let usermail = Cuurent_EMAIL();


  useEffect(() => {
    const text = document.getElementsByClassName("MuiTablePagination-selectLabel");
    [...text][0].innerHTML = "Show";
    [...text][0].style.fontSize = "13px"
  }, [])

  useEffect(() => {
    // if (searchInput == "") {
    //   setData(dataCopy)
    // }
    // else {
    //   setData(dataCopy?.filter((i) => {

    //     return i.controlRefNo == searchInput || (i?.tags?.toString().toLowerCase()) == searchInput?.toString().toLowerCase()
    //   }))
    // }
    filterDataWithSearchInput(dataCopy, searchInput, setData);
  }, [searchInput])

  const getControlReferenceData = async () => {
    setLoading(true);


    let body = {
      "startDate": moment(selectedFromDate).format('YYYY-MM-DD'),
      "endDate": moment(selectedToDate).format('YYYY-MM-DD'),
    }

    try {
      let controlRefData = await POST(Url.getControlReferenceTableData, token, body);
      if (controlRefData?.SUCCESS) {
        setData(controlRefData?.DATA)
        setCopyData(controlRefData?.DATA)
        setLoading(false);
      }
      else if (controlRefData?.STATUS == 401) {
        setLoading(false)

        setSessionExpiredModal(true);
        setFailMessage("Session Expired")
      }
      else {
        setLoading(false);
        setFailMessage("Failed to fetch data.");
        setOpenFailModal(true);
      }

      setLoading(false);

    } catch (error) {

      setLoading(false);
      setFailMessage("Failed to fetch data.");
      setOpenFailModal(true);
    }
  }

  useEffect(() => {
    if (selectedFromDate) {
      getControlReferenceData()
    }
  }, [selectedFromDate, selectedToDate])
  // ----------------------------------------------------------------------------------Table-------------------------------------------------------------------------------
  const theme = createTheme();
  const tableIconsControlRef = createTableIcons();
  const ModalCss = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "75%",
      height: "95%",
      padding: 15,
      zindex: 10000
      // marginTop: "20px",
    },
  };
  // ---------------------------------------------------------------------------------------Handle Full View Functionallity-------------------------------------------------------------------------
  // const handleCloseFullView = (setFullView) => {
  //   setFullView((prevState) => ({
  //     isClicked: false,
  //     viewMoreAttendees: false,
  //     typeOfMeeting: null,
  //     data: {}
  //   }));
  // }

  // const myFormats = {
  //   monthHeaderFormat: (date) => {
  //     // Format the date as desired, for example: "January 2024"
  //     return `${moment(date).format('MMMM YYYY')} (${monthlyCount.currentCount})`;
  //   },
  // };

  return (
    <div className='control-ref-main'>
      <div className='filter-container'>
        <div className="select-period-cref">
          <div
            data-testid="SelectPeriod"
            onClick={() => setOpenFromDatePicker(!openFromDatePicker)}
            onBlur={() => setTimeout(() => {
              setOpenFromDatePicker(false)
            }, 500)}
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <span style={{ marginLeft: '7px', color: "#999999" }}>Select Period &nbsp; &nbsp;</span>
            <label htmlFor='recEndDateFrom'>From: </label>
            <div className='from-datepicker-cont'>
              <span style={{ marginRight: "15px", display: "flex", padding: '5px 0px' }}
                data-testid="recEndDateFromspan" onClick={() => document.getElementById("recEndDateFrom").click()}
              >
                <svg
                  id="calendar-line-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14px"
                  height="14px"
                  viewBox="0 0 27.119 27.122"

                >
                  <path
                    id="Path_15922"
                    data-name="Path 15922"
                    d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                    fill="#00aff1"
                  />
                </svg>
              </span>
              <DatePicker
                id='recEndDateFrom'
                name="recEndDate"
                style={{ color: "#B8B8B8" }}
                // open={openFromDatePicker}
                showTimeSelect={false}
                selected={selectedFromDate}
                onChange={(date) => {
                  const selectedFromTimestamp = selectedFromDate && selectedFromDate.getTime();
                  const dateTimestamp = date && date.getTime();
                  if (selectedFromTimestamp !== dateTimestamp) {
                    handleDateChange("FromDate", date,setSelectedToDate,setSelectedFromDate);
                  }
                }}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>
          <div
            data-testid="recEndDateTodiv"
            onClick={() => setOpenToDatePicker(!openToDatePicker)}
            onBlur={() => setTimeout(() => {
              setOpenToDatePicker(false)
            }, 500)}
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <label htmlFor='recEndDateTo'>To: </label>
            <div className='from-datepicker-cont'>
              <span style={{ marginRight: "15px", display: "flex", padding: '5px 0px' }}
                data-testid="recEndDateTospan" onClick={() => document.getElementById("recEndDateTo").click()}
              >
                <svg
                  id="calendar-line-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14px"
                  height="14px"
                  viewBox="0 0 27.119 27.122"
                >
                  <path
                    id="Path_15922"
                    data-name="Path 15922"
                    d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                    fill="#00aff1"
                  />
                </svg>
              </span>
              <DatePicker
                id='recEndDateTo'
                name="recEndDate"
                style={{ color: "#B8B8B8" }}
                // open={openToDatePicker}
                showTimeSelect={false}
                selected={selectedToDate}
                onChange={(date) => handleToDateChange(date, selectedToDate, handleDateChange, setSelectedToDate, setSelectedFromDate)}
                dateFormat="dd/MM/yyyy"
                minDate={selectedFromDate}
              />
            </div>
          </div>
        </div>
        <div>
          <div className='serchbox'>
            <BsSearch fill='#999999' />
            <input type="text" placeholder='Search by Control Reference Id' value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
          </div>
        </div>
      </div>
      <div className="table-container cref-table">
        <ThemeProvider theme={theme}>
          <MaterialTable
            data={data}
            localization={{ body: { emptyDataSourceMessage: <span className="no_data_found_table">No Records to show</span> } }}
            columns={columns}
            icons={tableIconsControlRef}
            options={{
              // showTitle:false,
              toolbar: false,
              // headerStyle: tableHeaderStyle,
              draggable: false,
              search: false,
              pageSizeOptions: [5, 10, 15, 20],
              pageSize: 10,
              headerStyle: {
                position: 'sticky',
                top: -1,
                ...tableHeaderStyle
              },
              maxBodyHeight: '65vh',
              minBodyHeight: '65vh',
            }}
          />
        </ThemeProvider>
      </div>

      <Modal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={() => closeModal(setModalIsOpen, setFullView, setDatePickerDate)}
        style={ModalCss}
        contentLabel="Example Modal"
      >
        <div className='meetings-popup-main-container'>
          <div className='controll-ref-meeting-popup-title'>
            Control reference meeting details  ( From {moment(selectedFromDate).format('DD-MM-YYYY')} To {moment(selectedToDate).format('DD-MM-YYYY')} )
          </div>
          <div className='meetings-popup-info-container'>
            <span style={{ textAlign: "left", color: "#999999" }}>Control Reference : <span className='meetings-popup-text' >{selectedControlRef?.controlRefNo}</span></span>
            <span style={{ textAlign: "left", color: "#999999", }}>Description : <span className='meetings-popup-text' >{selectedControlRef?.controlRefShort}</span></span>
            <span style={{ textAlign: "right", color: "#999999" }}>Total Meetings : <span className='meetings-popup-text' >{selectedControlRef?.meetingCount}</span></span>
          </div>
          {

            <div className="event-cal" style={{ height: "90%" }}>
              <Calendar
                localizer={localizer}
                events={monthlyEvents}
                formats={myFormats(monthlyCount)}
                key={monthlyEvents}
                date={datePickerDate}
                startAccessor="start"
                endAccessor="end"
                style={{ height: "100%" }}
                views={['day', 'week', 'month']}
                view={view}
                // toolbar={view !== "month" && true}
                components={{
                  event: (props) => (
                    <CustomEvent
                      {...props} 
                      setLoading={setLoading}
                      token={token}
                      setFullView={setFullView}
                      setFullViewCancelModal={setFullViewCancelModal}
                      setFullViewModal={setFullViewModal}
                      setSessionExpiredModal={setSessionExpiredModal}
                      setFailMessage={setFailMessage}
                      setViewPastMeeting={setViewPastMeeting}
                      setFromPastMeeting={setFromPastMeeting}
                      navigate={navigate}
                      rbac={rbac}
                      usermail={usermail}
                    />
                  ),
                  toolbar: CustomMonthHeader
                }}
              />
            </div>
          }
          <AiOutlineClose
            className="meetings-popup-close"
            fill="#00ADEE"
            onClick={() => closeModal(setModalIsOpen, setFullView, setDatePickerDate)}
          />
          {
            !fullView?.isClicked &&
            <>

            </>
          }
        </div>
      </Modal>

      {/* -----------------------------------------Upcoming full view--------------------------------------------------------- */}
      <UpcomingMeetingModal
        isOpen={FullViewModal}
        onRequestClose={() => handleOnRequestCRfCloseUPMModal(handleCloseFullView,setFullView, setFullViewModal, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight)}
        customStyles={modalStyles}
        fullView={fullView}
        setFullView={setFullView}
        setAgendaDivHeight={setAgendaDivHeight}
        setMsgDivHeight={setMsgDivHeight}
        setAttendeesDivHeight={setAttendeesDivHeight}
        attendeesDivHeight={attendeesDivHeight}
        agendaDivHeight={agendaDivHeight}
        msgDivHeight={msgDivHeight}
        stripHtmlTags={stripHtmlTags}
      />
 {/* ----------------------------------------------------Cancel meeting full view ------------------------------------------------ */}
      <CancelledMeetingModal
        isOpen={FullViewCancelModal}
        onRequestClose={()=>handleCref_C_CloseModalOnRequest(handleCloseFullView,setFullViewCancelModal,setFullView)}
        customStyles={modalStyles}
        fullView={fullView}
        setFullView={setFullView}
        agendaDivHeight={agendaDivHeight}
        extractTextFromHtml={stripHtmlTags}
      />

 {/* ---------------------------------------------------------------------------Popups--------------------------------------------------------------------------------- */}
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleCloseFailModel(setOpenFailModal)}
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal)}
      />
      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleSessionExpClose(sessionStorage, navigate, setActive)}
        recallFunctiononClose={() => handleSessionExpClose(sessionStorage, navigate, setActive)}
      />
    </div>
  )
}

export default ControlReference